/* eslint-disable react-hooks/exhaustive-deps */
import {useMemo, useState} from "react"
import {AppliedFilter, FilterKey, FilterList} from "types/filter"
import {StudentVoiceMailFilter, StudentVoiceMailListView} from "./parts"

type Props = {
    departmentId: number
    filterKey: FilterKey
    studentProfileId?: number
}

const INITIAL_FILTER: AppliedFilter = {
    search: "",
    filters: {}
}

export function VoiceMail(props: Props) {
    const {departmentId, filterKey, studentProfileId} = props
    const [appliedFilter, setAppliedFilter] = useState<AppliedFilter>()

    const onApplyFilter = (payload: AppliedFilter) => {
        setAppliedFilter(payload)
    }

    const filterParams = useMemo(() => {
        const {status, students, program, campus} = appliedFilter?.filters ?? {}

        let filter: FilterList = {}

        if (students) {
            filter.studentUserIds = {
                operator: students.operator,
                value: students.value.map(({id}) => id)
            }
        }
        if (program) {
            filter.programIds = {
                operator: program.operator,
                value: program.value.map(({id}) => id)
            }
        }
        if (campus) {
            filter.campusIds = {
                operator: campus.operator,
                value: campus.value.map(({id}) => id)
            }
        }
        if (status) {
            filter.status = {
                operator: status.operator,
                value: status.value.id
            }
        }

        return {
            filters: filter,
            search: appliedFilter?.search,
            studentProfileId: studentProfileId
        }
    }, [appliedFilter])

    return (
        <div>
            <StudentVoiceMailFilter
                filterKey={filterKey}
                initialFilter={INITIAL_FILTER}
                onApplyFilter={onApplyFilter}
                onClearFilter={() => onApplyFilter({filters: {}, search: ""})}
            />
            <StudentVoiceMailListView
                filterKey={filterKey}
                filterParams={filterParams}
                departmentId={departmentId}
                studentProfileId={studentProfileId}
            />
        </div>
    )
}
